<template>
  <md-card class="card-servico m-0">
    <router-link tag="div" :to="link" class="front-card">
      <h4 class="bold m-0 md-display-1 text-white tx-servico bold">{{ titulo }}</h4>
    </router-link>
    <div class="back-card"
         :style="{
         backgroundImage: `url('${imgBg}')`,
         backgroundPosition: 'center center',
         backgroundRepeat: 'no-repeat',
         backgroundSize: 'cover'
         }"></div>
  </md-card>
</template>

<script>
  export default {
    name: 'WidgetServico',
    props: {
      imgBg: { default: require('../assets/background/bg_null.jpg') },
      titulo: { type: String, default: "Titulo" },
      link: { type: String, default: "/" },
    }
  }
</script>

<style scoped lang="scss">

  .card-servico {
    width: 100%;
    height: 145px;
    overflow: hidden;
    color: #fff;
    text-transform: uppercase;

    .front-card {
      transition: 250ms;
      position: absolute;
      z-index: 2;
      display: flex;
      width: 100%;
      cursor: pointer;
      justify-content: center;
      align-items: center;
      height: 100%;
      &:hover {
        background-color: rgba(0, 0, 0, 0.2);
      }

      .tx-servico {
        filter: drop-shadow(1px 1px 2.1px rgba(0, 0, 0, 0.46));
      }
    }

    .back-card {
      position: absolute;
      width: 100%;
      height: 100%;
      z-index: 1;
      background-origin: border-box;
      background-size: cover;
    }
  }

</style>
